import { useContext } from 'react';

import { TableProContext } from '.';

export const useTablePro = () => useContext(TableProContext);
